import { careersEn } from './careers-en'
import { memberEn } from './member-en'

export default {
  ...careersEn,
  ...memberEn,
  nav: {
    home: 'HOME',
    about: 'ABOUT',
    rd: 'R&D',
    innovation: 'Innovation',
    pipelineStrategy: 'Pipeline & Strategy',
    science: 'Science',
    expandedAccess: 'Expanded Access Policy',
    pipeline: 'Pipeline',
    disease: 'Disease Areas',
    strategy: 'Strategy',
    news: 'NEWS',
    careers: 'CAREERS',
    detail: 'Job Detail',
    contact: 'CONTACT',
    ir: 'Investors',
    annoucement: 'Annoucement',
    presentation: 'Presentation',
    irContact: 'IR Contact',
    governance: 'Governance',
    stock: 'Stock'
  },
  ir: {
    AoA: 'Articles of Association',
    interim: 'Interim Notice',
    periodic: 'Periodic Notice'
  },
  ir_contact: {
    name: 'IR Department',
    addr: '199 Liangjing Rd, Zhangjiang Hi-Tech Park, Pudong District, Shanghai, China, 201203',
    tel: '+86-21-61095757',
    email: 'IR@dizalpharma.com'
  },
  core_value: {
    name: 'Core Value',
    value1: 'World-class innovation',
    value2: 'Learning organization',
    value3: 'Compete to win',
    aim: 'We are committed to addressing unmet medical needs.'
  },
  about: {
    our_story: 'Our Story',
    about_us: 'About Us',
    about_dizal: 'About Dizal',
    about_1:
      'Dizal is a biopharmaceutical company, dedicated to the discovery, development and commercialization of differentiated therapeutics for the treatment of oncology and hematological diseases. The company aims to develop first-in-class and groundbreaking new medicines, and further address unmet medical needs around the world. Deep-rooted in translational science and molecular design, Dizal has established an internationally competitive portfolio. Golidocitinib is approved in China. ZEGFROVY® is approved in both the U.S. and China, with worldwide development and commercialization rights licensed to AstraZeneca.',
    about_2: ''
  },
  strategy: {
    strategy_1: 'Aiming at the treatment of oncology and hematological diseases as well as other critical diseases.',
    strategy_2: 'Maintaining our competitive edges in the capabilities of translational science, medicinal chemistry and drug design.',
    strategy_3: 'Expanding global competitive portfolio mainly through internal drug discovery engine.'
  },
  campus_timeline: [
    {
      year: '2022.08.31',
      text: 'Online Application Launch'
    },
    {
      year: '2022.09-10',
      text: 'Campus Career Talk'
    },
    {
      year: '2022.09-10',
      text: 'Resume Screening'
    },
    {
      year: '2022.10-11',
      text: 'Interview'
    },
    {
      year: '2022.11-12',
      text: 'Send Offer'
    }
  ],
  contact_us: 'Contact Us',
  more: 'more',
  management: 'Management Team',
  board: 'Board of Directors',
  jobs: 'Opportunities',
  campus: 'Campus Hiring',
  copyright: 'DizalPharma. All Rights Reserved.',
  site_ref: 'Site Reference No：',
  //   Home: "Home",
  read_more: 'Read More',
  news_list: 'NEWS LIST',
  news_detail: 'NEWS DETAIL',
  return_to_news_list: 'Return to News List',
  oncology: 'Oncology',
  non_oncology: 'Non-oncology',
  pipeline: {
    table: {
      project: 'Project',
      discovery: 'Discovery',
      IND_Enabling: 'IND Enabling',
      Ph1_does: 'Dose Escalation',
      Ph2_proof: 'Proof of Concept',
      Ph3_pivotal: 'Pivotal',
      NDA: 'NDA',
      approval: 'Approval',
      Ph1: 'Phase I',
      Ph2: 'Phase II',
      Ph3: 'Phase III',
      territories: 'Territories',
      territoriesSunvozertinib: '（Out-licensed）',
      global: 'Global',
      dizal_AZ_split: 'Dizal/AZ split',
      PTCL: 'PTCL',
      HM: 'Hematological Malignancy',
      autoimmuneDiseases: 'Immunological Diseases',
      solidLiquidTumors: 'Solid & Liquid Tumors',
      solidTumors: 'Solid Tumors',
      Sunvozertinib: 'ZEGFROVY®',
      Golidocitinib: 'Golidocitinib',
      DZD1516: 'DZD1516',
      DZD2269: 'DZD2269',
      DZD8586: 'Birelentinib',
      DZD6008: 'DZD6008',
      GW5282: 'GW5282',
      CKD: 'CKD',
      anti_virus: 'Anti-Viral',
      ps1: 'Note：1. Dizal grants AstraZeneca worldwide rights to develop and commercialise ZEGFROVY',
      ps2: 'Note：2. The progress bar indicates the highest development phase of the project.',
      hematologicalMalignancy: 'Hematological Malignancy',
      sunvozertinibTip: ['Breakthrough Therapy Designation by NMPA and FDA', 'Priority Review by NMPA and FDA'],
      GolidocitinibTip: ['Fast Track Designation by FDA', 'Orphan Drug Designation by FDA', 'Priority Review by NMPA'],
      BirelentinibTip: ['Fast Track Designation by FDA'],
      recognition: 'Regulatory Designations'
    }
  },
  publications: {
    key: 'Publications',
    core: 'Science is the foundation for all Dizal does.',
    intro: 'With deep-rooted science-led culture, our pioneering scientists regularly publish their research in peer-reviewed journals and deliver presentations at world-leading scientific conferences.',
    tab: {
      Sunvozertinib: 'Sunvozertinib',
      Golidocitinib: 'Golidocitinib',
      DZD2269: 'DZD2269',
      DZD8586: 'Birelentinib',
      DZD6008: 'DZD6008',
      DZD1516: 'DZD1516'
    }
  },
  lung: 'LUNG CANCER',
  chronic: 'CHRONIC',
  kidney: 'KIDNEY DISEASE',
  inflammatory: 'INFLAMMATORY',
  bowel: 'BOWEL DISEASE',
  anti_virus: 'ANTI-VIRUS',
  anti_virus_project: 'Anti-Virus Project',
  apply: 'Apply',
  company_name: 'Dizal Pharma',
  tel: 'Tel',
  fax: 'Fax',
  email: 'Email',

  return_to_jobs: 'Return to Job List',
  back_to_news: 'Back to News List',

  we: 'WE',
  follow_us: 'Follow Us By',
  latest_news: 'Latest News',
  job: {
    intro: ['We are looking for candidates who share our core values.', 'At Dizal, we offer various career opportunities with a competitive salary and benefits package. ', 'If you are interested in the open positions, please send C.V. to'],
    detail_btn: 'JOB DETAILS',
    list_name: 'Job List'
  },
  location: {
    name: 'Location',
    more: 'Find more',
    detail1: 'Dizal China is located in Zhangjiang Hi-Tech Park, Shanghai, where our R&D, Commercial and operation are located. We also have branch offices in Beijing, Wuxi, and Chengdu.',
    detail2: 'Our locations enable us to partner with academic, research and healthcare neighbors to explore life-changing therapeutics. Our state-of-the-art facility is well equipped and tailor-made for R&D into the entire lifecycle of a medicine.',
    address: {
      Shanghai: {
        name: 'Shanghai',
        addr: '199 Liangjing Rd, Zhangjiang Hi-Tech Park, Pudong District, Shanghai, China, 201203',
        tel: '+86-21-61097800',
        fax: '+86-21-58387361',
        email: 'info@dizalpharma.com'
      },
      Beijing: {
        name: 'Beijing',
        addr: 'Room 2309, 23 Floor, Tower 2, China Central Place (CCP) Office Building, NO.79 Jianguo Road, Chaoyang District, Beijing 100022',
        tel: '+86-10-87513588',
        fax: '+86-10-58043622'
      },
      Wuxi: {
        name: 'Wuxi',
        addr: 'Room 404, Building C, Huirong Plaza, 26 Hefeng Rd, Xinwu District, Wuxi, Jiangsu, China, 214028 '
      },
      Chengdu: {
        name: 'Chengdu',
        addr: 'Unit 8, 31/F, Yanlord Landmark, No.1, Second Section, Renmin South Road, Jinjiang District, Chengdu, China, 610020'
      }
    }
  },
  see_map: 'See Map',
  terms_of_use: {
    name: 'Terms Of Use',
    content: [
      // 法律声明
      {
        subtitle: 'Legal Declaration',
        intro: [
          {
            dec: 'This website was created and maintained by Dizal Pharmaceutical Co. Ltd. (hereinafter referred to as "Dizal Pharma") . Anyone who enters the website, reads any content, registers for users, downloads any material from the website or uses the information provided by this website, agrees to comply with the following terms. These provisions constitute a agreement between you and Dizal Pharma. Do not use this website if you do not agree to comply with these terms. Dizal Pharma reserves the right to update the following terms at any time without notice, which will also bind you. Dizal Pharma obtains the rights to reject any access and the usage of the website at any time in any case.',
            addition: []
          },
          {
            dec: 'Dizal Pharma reserves the rights of correction, modification and updating this statement at any time.',
            addition: []
          }
        ]
      },
      // 版权声明
      {
        subtitle: 'Copyright Declaration',
        intro: [
          {
            dec: 'Dizal Pharma independently owned the copyright of all information in this website, or jointly own the website copyright with data provider who provides the data on this website or relevant website. Without the express written permission of Dizal Pharma, any person shall not copy or produce server images in non Dizal Pharma server for any content on this website.',
            addition: []
          },
          {
            dec: "The domain name, trademark, content, visual image and sound, figure and pictures contained in this website are protected by relevant trademarks and copyright regulations. Without prior written permission of Dizal Pharma, any enterprise or individual shall not be copied or transmitted in any form. Any unauthorized use of this website will violate the provisions of the copyright law of the People's Republic of China and other relevant laws and regulations, as well as the relevant international conventions.",
            addition: []
          }
        ]
      }
    ]
  },
  privacy_policy: {
    name: 'Privacy Policy',
    content: [
      {
        subtitle: null,
        intro: [
          //   介绍项
          {
            dec: 'This privacy statement applies to all the user of " Dizal Pharma " website (hereinafter referred to as the site). We respect and protect users\' privacy, and solemnly promise that unless we have legal or procedural requirements, we will not publish personal information related to users unless authorized by users. We will regularly check the privacy protection measures to ensure the privacy protection of the user\'s personal data.',
            addition: []
          },
          {
            dec: 'Privacy Notice on Personal Information Protection',
            link: {
              text: 'Notice on Collection, Processing & Cross-border Transfer of Personal Information via 400 Hotline',
              href: 'https://www.dizalpharma.com/static/pdf/400热线个人信息收集处理和出境知情告知.pdf'
            }
          },
          {
            dec: 'In the following exceptions, the foregoing promises will not be guaranteed and the relevant information of the users will be disclosed. These cases included but are not limited to:',
            addition: [
              'when the user on the site in violation of the " Computer Information Network Internet Security, Protection Management Regulations ", "Internet Information Services Management Regulations", or may damage or interfere the rights of other users, the disclosure of personal information of users to identify, contact or take legal action if necessary.',
              'personal information that must be disclosed requested by laws and regulations.',
              'when a judiciary authorities or other authorized institution executes official duties in accordance with the law, it requires the website to publish a specific personal information.'
            ]
          },
          {
            dec: 'This website has the technical methods and comprehensive security protection system to ensure the maintenance of user privacy data, but this site does not bear any legal responsibility for the user information leaks, damages, losses due to the force majeure, computer virus or hacker attacks and etc.',
            addition: []
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/lang/common-en.js